import { Component, OnInit, ViewChild } from '@angular/core'
import { MatTableDataSource } from '@angular/material/table'
import { MatSort } from '@angular/material/sort'
import { MatPaginator } from '@angular/material/paginator'
import { DepartamentoService } from 'src/app/services/departamento-service'
import { DepartamentoAprovarInscricao } from 'src/app/models/departamento-aprovar-inscricao'
import { UnespCoreAuthService, UnespCoreUserService } from '@unesp/core'
import { UsuarioLogin } from 'src/app/models/usuario-login'
import { DataService } from 'src/app/services/data-service'

@Component({
  selector: 'app-departamento-aprovar-inscricao',
  templateUrl: './departamento-aprovar-inscricao.component.html',
  styleUrls: ['./departamento-aprovar-inscricao.component.css'],
  standalone: false
})
export class DepartamentoAprovarInscricaoComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator
  @ViewChild(MatSort) sort!: MatSort

  colunasGrid: string[] = [
    'id',
    'nome',
    'programa',
    'nomeDisciplina',
    'codigoDisciplina',
    'semestre',
    'status',
    'action',
  ]
  dataSource: MatTableDataSource<DepartamentoAprovarInscricao> = new MatTableDataSource()

  anos: number[] = []
  anoSelecionado: number = 0
  idDepartamentoSecao: number = 0
  idUnidade: number = 0

  constructor(
    private departamentoService: DepartamentoService,
    private unespCoreUserService: UnespCoreUserService,
    private dataService: DataService,
    private unespCoreAuthService: UnespCoreAuthService
  ) {}

  ngOnInit(): void {
    this.anos = this.dataService.listYearsSince2022()
    this.anoSelecionado = this.dataService.getCachedYearSince2022()
    this.unespCoreUserService.user$.subscribe(user => {
      this.idDepartamentoSecao = (user as UsuarioLogin).idLotacaoOficial ?? 0
      this.idUnidade = (user as UsuarioLogin).idUnidadeUniversitaria ?? 0
      this.getData()
    })
  }

  getData(): void {
    this.dataService.setCachedYearSince2022(this.anoSelecionado)
    this.departamentoService
      .aprovarInscricao(this.idDepartamentoSecao, this.idUnidade, this.anoSelecionado)
      .subscribe(data => {
        this.dataSource = new MatTableDataSource(data)
        this.dataSource.sort = this.sort
        this.dataSource.paginator = this.paginator
      })
  }

  search(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value
    this.dataSource.filter = filterValue.trim().toLowerCase()
  }

  isChefeDepartamento(): boolean {
    return this.unespCoreAuthService.hasPermissionBasedRoles(['DEPARTAMENTO'])
  }
}
